import React from 'react';
import {Box, Grid2, Typography} from '@mui/material';

const ComingSoonGame: React.FC = () => {
  return (
    <Grid2 id='coming-soon-game' container justifyContent="center" alignItems="center" spacing={{xs: 1, md: 2}}
           columns={{xs: 4, sm: 8, md: 10}}>
      <Grid2 size={{xs:10}} className={'grid-coming-soon'}>
        <Typography className='title'>
          Coming Soon
        </Typography>
        <Typography className='txt'>
          Please register to our newsletter and follow our social media to get updates on our upcoming games.
        </Typography>
        <Typography className='txt2'>
          Subscribe to the newsletter
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default ComingSoonGame;